import { AddEditJobRequest } from '../../domain/requests/jobs/add-edit-job.request';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { UseCase } from "../../base/use-case";
import { JobsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class AddJobUsecase implements UseCase<AddEditJobRequest, boolean> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: AddEditJobRequest): Observable<boolean> {
    return this.jobRepository.addJob(params);
  }

}
